import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Props } from 'react-intl/src/components/message';

type ErrorValue = undefined | null | string | Pick<Props, 'id' | 'values'>;

/**
 * @deprecated this is exposed for a couple of cases where the hook is not usable; prefer the hook!
 */
export const getFormattedErrorMessage = (error: ErrorValue) => {
  if (!error) {
    return;
  }

  if (typeof error === 'string') {
    // biome-ignore lint/plugin: this should be tracked at the source
    return <FormattedMessage id={error} />;
  }

  // IMPORTANT: we expect that the error message key has been made trackable via comments
  // in the codebase, if that was not done the translation key will not be available
  const { id: errorMessageIntlKey, values } = error;
  return <FormattedMessage id={errorMessageIntlKey} values={values} />;
};

// TODO: rename to useFormattedErrorMessage
const useErrorMessage = (error: ErrorValue) =>
  useMemo(() => getFormattedErrorMessage(error), [error]);

export default useErrorMessage;
